import React from "react";

const QIA_THINKING_SRC = (process.env.PUBLIC_URL || "") + "/assets/qia/animation_thinking.webm";

function QiaLoader({ label, size = 40 }) {
    return (
        <div className="qia-typing-row qia-fadeup">
            <video
                className="qia-state-anim"
                style={{ width: size, height: size }}
                src={QIA_THINKING_SRC}
                muted
                autoPlay
                loop
                playsInline
            />
            {label && <span className="qia-state-label">{label}</span>}
        </div>
    );
}

export default QiaLoader;
